var PIGGY_BANK_CACHE_TAGS = {
  PIGGY_BANK: 'PiggyBank'
};
PIGGY_BANK_CACHE_TAGS.piggyBankTagsArray = Object.values(PIGGY_BANK_CACHE_TAGS);
export { PIGGY_BANK_CACHE_TAGS };